import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-quick-actions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-quick-actions.component.html',
  styleUrl: './dashboard-quick-actions.component.scss'
})
export class DashboardQuickActionsComponent {
  constructor(private router: Router) {}

  openPsychometricTest() {
    this.router.navigate(['portal', 'psychometric-test']);
  }

  openExploreColleges() {
    this.router.navigate(['portal', 'institute-search']);
  }

  openPeerConnect() {
    this.router.navigate(['portal', 'peer']);
  }
}
